import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { FooterSection } from '../footer/FooterSection';
import { MimicHeader } from '../navbar/MimicHeader';
import { SFCNavbar } from '../navbar/SFCNavbar';
import './SFCLayout.css';

export const SFCLayout = () => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    return (
        <>
            <MimicHeader />
            <SFCNavbar />
            <div
                className="content min-vh-100"
                style={{ background: location.pathname !== '/recipes' ? '#FAFAFA' : '#FFF' }}
            >
                <Outlet />
                <FooterSection />
            </div>
        </>
    );
};